import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import {
  createTranslateLoader,
  GkComponentsModule,
  GkKendoModule,
  GkMapModule,
  LandUseClassFormComponent,
  LandUseClassFormService,
} from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { PARNewRequestComponent } from './new-request/new-request.component';
import { PlanningActRequestRoutingModule } from './planning-act-request-routing.module';
import { PlanningActRequestComponent } from './planning-act-request.component';
import { PARNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [PlanningActRequestComponent, PARNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkKendoModule,
    GkComponentsModule,
    PlanningActRequestRoutingModule,
    MatSelectModule,
    MatCheckboxModule,
    LandUseClassFormComponent,
  ],
  providers: [PARNewRequestFormService, LandUseClassFormService],
})
export class PlanningActRequestModule {}
